<template>
  <div class="list" :class="{ 'white-mode': !darkMode }">
    <div class="list__item" v-for="item in list" :key="item.clauseCode" @click="clickHandler(item.clauseCode)">
      {{ item.name }}
    </div>
  </div>
</template>
<script setup>
import api from "../api";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const list = ref([]);
const darkMode = ref(true);
if (route.query && route.query.mode === "white") {
  darkMode.value = false;
}
const clauseCode = ["TK002", "TK009", "TK011"]
api
  .post("/clause/action/queryList", {
    params: {
      clauseCode
    }
  })
  .then(
    (res) => {
      if (res.status === 200 && res.data.code === "0") {
        res.data.body.map(v => {
          const index = clauseCode.findIndex(_v => _v === v.clauseCode)
          v.sort = index
          return v
        })
        res.data.body.sort((a, b) => a.sort - b.sort)
        list.value = res.data.body;
      }
    },
    () => { }
  );
const clickHandler = (clauseCode) => {
  router.push({
    name: "PolicyPage",
    params: {
      id: clauseCode,
    },
    query: {
      token: "421459faa4e1f6d564f67d138620be8d",
      mode: route.query.mode || "dark",
    },
  });
};
</script>
<style lang="scss" scoped>

.list {
  background: #0b0b0b;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-size: 30px;
  color: #fff;
}

.white-mode{
  background-color: #fafafa;
  color: #232323;
  padding-top: 32px;
  .list__item {
    background-color: #fff;
    margin: 0 32px;
    padding: 0 30px;
  }
  .list__item:after {
    content: "";
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #232323;
    border-bottom: 2px solid #232323;
    transform: rotate(-45deg);
  }
}
.list__item {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
}

.list__item:after {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
}
</style>
